export default "__VITE_ASSET__b37cb08a__"